import { render, staticRenderFns } from "./DummyDashboard.vue?vue&type=template&id=1ce2f09c&"
import script from "./DummyDashboard.vue?vue&type=script&lang=js&"
export * from "./DummyDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports